"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M24 1A23.013 23.013 0 0 0 1.1 24.14a22.9 22.9 0 1 0 45.8 0A23.012 23.012 0 0 0 24 1zm0 43.72a20.581 20.581 0 0 1 0-41.16 20.581 20.581 0 0 1 0 41.16z" }),
  React.createElement("path", { d: "M25.62 24.26l10.82-3.06c.98 4.14.34 7.62-2.82 10.88zm6.76 8.7a12.174 12.174 0 0 1-16.74-.6 11.938 11.938 0 0 1-.46-16.54zM24 22.32l-8.18-7.74a11.451 11.451 0 0 1 11.12-3.12zm1 .82l3.06-10.94a10.561 10.561 0 0 1 4.96 2.72 12.05 12.05 0 0 1 3 5.1zm9.22-9.42A14.012 14.012 0 0 0 27.5 10l-.26.32a13.537 13.537 0 0 0-12.5 3.54l-.44-.4A14.314 14.314 0 1 0 34.54 33.7l-.4-.4a13.734 13.734 0 0 0 3.46-12.72l.4-1a14.47 14.47 0 0 0-3.78-5.86z" })
);

